import { render, staticRenderFns } from "./Sv2Score.vue?vue&type=template&id=39688ddc&scoped=true&"
import script from "./Sv2Score.vue?vue&type=script&lang=js&"
export * from "./Sv2Score.vue?vue&type=script&lang=js&"
import style0 from "./Sv2Score.vue?vue&type=style&index=0&id=39688ddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39688ddc",
  null
  
)

export default component.exports